import { Button, lighten, Paper, Stack, ToggleButton, Typography } from "@mui/material";
import _ from 'lodash';
import React, { useState } from "react";

export default function SubjectsStep(props) {
	const [subjects, setSubjects] = useState([]);

	const sampleSubjects = [
		{ name: "Art", colour: "#e17f66" },
		{ name: "Computers", colour: "#67304c" },
		{ name: "Critical Thinking", colour: "#817f26" },
		{ name: "Geography", colour: "#492c63" },
		{ name: "Health & Fitness", colour: "#824e21" },
		{ name: "History", colour: "#5e3c2d" },
		{ name: "Language Arts", colour: "#2d436b" },
		{ name: "Math", colour: "#2e5a40" },
		{ name: "Religion", colour: "#373737" },
		{ name: "Science", colour: "#86652e" },
		{ name: "Social Studies", colour: "#16417c" },
		{ name: "World Languages", colour: "#817f26" },
	];

	const toggleSubject = (subject) => {
		const index = _.findIndex(subjects, subject);
		if (index < 0) {
			subjects.push(subject);
		}
		else {
			_.pullAt(subjects, index);
		}
		setSubjects([...subjects]);
	}

	const saveSubjects = () => {
		props?.onNext?.();
	};

	return (
		<React.Fragment>
			<Paper sx={props.sx}>
				<Typography variant="h3">Pick a few subjects you will be teaching:</Typography>
				<Stack justifyContent="center" useFlexGap sx={{ flexWrap: 'wrap' }} spacing={4}>
					{sampleSubjects.map(subject => (
						<ToggleButton value={subject} sx={{ height: 40, p: 4, backgroundColor: _.findIndex(subjects, subject) < 0 ? lighten(subject.colour, 0.9) : lighten(subject.colour, 0.6) }} size="large" onChange={(e, value) => toggleSubject(value)} key={'subjectButton' + subject.name}>{subject.name}</ToggleButton>
					))}
				</Stack>
			</Paper>

			<Stack justifyContent="space-between">
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => props?.onPrevious?.()}>Previous</Button>
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => saveSubjects()}>Next</Button>
			</Stack>
		</React.Fragment>
	);
}